import bleImage from "../../img/elements/bleicon.png"
import rubikaImage from "../../img/elements/minimal.png"
import {GoLocation, MdLocationCity} from "react-icons/all";
export const DETAILS = {
    name: " فروشگاه سلنا",
    shortName: "سلنا",
    footerName: "فروشگاه سلنا",
    description: "",
    shortAbout: "فروشگاه سلنا بزرگترین و معتبرترین فروشگاه لباس زیر در شهر کرج می باشد که هم به صورت حضوری و هم فروش آنلاین فعالیت گسترده ای دارد. در فروشگاه سلنا، بهترین برندهای لباس زیر موجود در بازار در دسترس مشتریان قرار دارند. کیفیت، زیبایی و راحتی لباس زیرهای سلنا آن چیزیست که رضایت مشتریان ما را همواره جلب کرده است.",
    veryShortAbout: "فروشگاه سلنا بزرگترین و معتبرترین فروشگاه لباس زیر در شهر کرج می باشد که هم به صورت حضوری و هم فروش آنلاین فعالیت گسترده ای دارد. در فروشگاه سلنا، بهترین برندهای لباس زیر موجود در بازار در دسترس مشتریان قرار دارند. کیفیت، زیبایی و راحتی لباس زیرهای سلنا آن چیزیست که رضایت مشتریان ما را همواره جلب کرده است.",
    link: "https://selenacenter.com",
    mobile: ["09380637888"],
    phone: [],
    email: [],
    postalCode: [],
    address: "کرج، شاهین ویلا، خیابان قلم، بین خیابان ۱۶و ۱۷ غربی فروشگاه سلنا",
    supportDescription: "",
    workingHours: ["شنبه تا پنجشنبه 10 تا 13 و 16:30 تا 21", "جمعه 17 تا 21"],
    mapIframeSrc: "https://neshan.org/maps/iframe/places/49d838fe71b0129488ba8bb46a3deef0#c35.887-50.980-12z-0p/35.86198099999999/50.9566971",

    socialMedia: [
        {
            title: 'واتس اپ',
            value: '09380637888',
            name: 'whatsapp',
            link: 'https://api.whatsapp.com/send/?phone=09380637888&text&app_absent=0',
            icon: <i className="lab la-whatsapp"/>,
            isPrimary: true,
            background:"#25D366"
        },
        {
            title: 'کانال ارسالی ها',
            value: 'moshtariselena',
            name: 'telegram',
            link: 'https://t.me/moshtariselena',
            icon: <i className="lab la-telegram-plane"/>,
            isPrimary: true,
            background:"#0088CC"
        },
        {
            title: 'اینستاگرام',
            value: 'selenacollectionkaraj',
            name: 'instagram',
            link: "https://instagram.com/selenacollectionkaraj",
            icon: <i className="lab la-instagram"/>,
            isPrimary: true,
            background:"linear-gradient(to right,#833ab4,#fd1d1d,#fcb045)"
        },
        {
            title: 'پیامرسان بله',
            value: 'selenacenter',
            name: 'ble',
            link: 'http://ble.ir/selenacenter',
            icon: <img src={bleImage} alt='بله' width={30}/>,
            isPrimary: true,
            background:"#09dab2"
        },
        {
            title: 'کانال روبیکا',
            value: 'selenacenter',
            name: 'ble',
            link: 'http://rubika.ir/selenacenter',
            icon: <img src={rubikaImage} alt='بله' width={30}/>,
            isPrimary: true,
            background:"#8710ce"
        },
        {
            title: 'مسیریابی',
            value: 'http://niksms.com/t/veUgwY2',
            name: 'location',
            link: 'http://niksms.com/t/veUgwY2',
            icon: <GoLocation />,
            isPrimary: true,
            background:"#01a5b7"
        },
        /*{
                    title: 'ایتا',
                    value: '09357195494',
                    name: 'eitaa',
                    link: 'https://eitaa.com/09357195494',
                    icon: <img src={eitaaIcon} alt='ایتا'/>,
                    isPrimary: false
                }
        {
            title: 'ایمیل',
            value: 'Volvotak@gmail.com',
            name: 'email',
            link: 'mailto:Volvotak@gmail.com',
            icon: <i className="las la-envelope"></i>,
            isPrimary: true
        },
        {
            title: 'تس',
            value: '09133377432',
            name: 'phone',
            link: 'tel:989133377432',
            icon: <PhoneCall/>,
            isPrimary: true
        },
                /*{
                    title: 'آپارات',
                    value: 'Alo_aghsat',
                    name: 'aparat',
                    link: 'https://www.aparat.com/Alo_aghsat',
                    icon: <SiAparat size={25}/>,
                    isPrimary: true
                },
                {
                    title: 'تماس',
                    value: '02636634893',
                    name: 'phone',
                    link: 'tel:+982636634893',
                    icon: <PhoneCall/>,
                    isPrimary: false
                },
                {
                    title: 'سروش پلاس',
                    value: '09331074475',
                    name: 'soroushPlus',
                    link: '',
                    icon: <img src={soroushIcon} alt='سروش'/>,
                    isPrimary: false
                },
                {
                    title: 'سروش پلاس',
                    value: '09332094475',
                    name: 'soroushPlus',
                    link: '',
                    icon: <img src={soroushIcon} alt='سروش'/>,
                    isPrimary: false
                },
                {
                    title: 'سروش پلاس',
                    value: '09330324475',
                    name: 'soroushPlus',
                    link: '',
                    icon: <img src={soroushIcon} alt='سروش'/>,
                    isPrimary: false
                },
                {
                    title: 'ایتا',
                    value: '09331074475',
                    name: 'eitaa',
                    link: '',
                    icon: <img src={eitaaIcon} alt='ایتا'/>,
                    isPrimary: false
                },*/
    ],
    services: [],
    brands: [
        /*{
            name: 'Apple',
            image: <img src={appleImage} alt='apple'/>,
        },*/
    ],
    "enamadLink": "",
    "samandehiLink": "",
    "ZarinpalLink": "https://www.zarinpal.com/webservice/TrustCode"
}
